// extracted by mini-css-extract-plugin
export default {"space_bluegrey":"#231f2a","space_black":"#1c171c","purple":"#4f257f","red":"#dc1919","skyblue":"#1cb1e0","bright_green":"#55af0e","mainDiv":"style_mainDiv__DgAHf"};